import { render } from "./Users.vue?vue&type=template&id=5a976bff&scoped=true&ts=true"
import script from "./Users.vue?vue&type=script&lang=ts"
export * from "./Users.vue?vue&type=script&lang=ts"

import "./Users.vue?vue&type=style&index=0&id=5a976bff&scoped=true&lang=css"

import exportComponent from "/home/lahiru-dhananjaya/Documents/Jeewaka/PMS/Source and Documentation/pharma-connect2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a976bff"]])

export default __exports__